import type { DateTime } from "luxon";
import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "../../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import type { NurseInShift } from "../../../../utils/models";
import { holidayForShift } from "../../../team/Holidays/schedule/scheduleHolidays";
import { usePageScheduleHolidays } from "../../../team/Holidays/schedule/scheduleHolidaysContext";
import { MobileNurseItem } from "./MobileNurseItem";

type MobileNursesListProps = {
	nurses: NurseInShift[];
	date: DateTime;
	weekIndex: number;
};

export const MobileNursesList: FC<MobileNursesListProps> = ({ nurses, date, weekIndex }) => {
	const navigate = useNavigate();
	const { chosenDepartment } = useHospitalData();
	const { track } = useAnalytics();
	const { holidays } = usePageScheduleHolidays();

	const onClick = useCallback(
		(id: string) => {
			track("nurse_shift_details_mobile", { nurse_in_shift_id: id });
			const path = `/${chosenDepartment.department_id}/shift/${id}`;
			navigate(path);
		},
		[navigate, track, chosenDepartment],
	);

	return (
		<>
			{nurses.map((nurse: NurseInShift) => (
				<MobileNurseItem
					key={nurse.id}
					nurse={nurse}
					onClick={onClick}
					weekIndex={weekIndex}
					dayIndex={date.weekday % 7}
					shiftHoliday={holidayForShift(nurse, holidays)}
				/>
			))}
		</>
	);
};
